import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ElevationService } from './elevation.service';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  private currentDealerSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null,
  );
  private routingNum: string;
  private allDealers: any[] = [];
  private admin: string = '';
  private access: boolean = false;

  public currentDealer$: Observable<any> =
    this.currentDealerSubject.asObservable();

  constructor(
    private elevationService: ElevationService,
    private appSettings: SettingsService,
  ) {}

  setDealer(dealer: any, saveToLocal: boolean = true): void {
    const fauxboxKey = dealer.fauxbox_key;
    this.appSettings.set({ apiKey: fauxboxKey });
    this.currentDealerSubject.next(dealer);
    if (saveToLocal) {
      sessionStorage.setItem('currentDealer', JSON.stringify(dealer));
    }
  }

  async setAccess(fauxbox_key, admin?: string): Promise<void> {
    const res = await this.elevationService
      .checkFauxboxAccess(fauxbox_key, admin)
      .toPromise();
    if (res.adminAccess) {
      this.admin = admin;
      this.access = true;
    } else {
      this.admin = 'NoAccess';
      this.access = res.access;
    }
  }

  getAdmin(): string {
    return this.admin;
  }

  getAccess(): boolean {
    return this.access;
  }

  getDealer(): any {
    return this.currentDealerSubject.getValue();
  }

  getRoutingNum(): string {
    return this.routingNum;
  }

  async updateRoutingNum(routingNum: string): Promise<void> {
    if (this.routingNum === routingNum) {
      return;
    }
    this.routingNum = routingNum;
    this.allDealers = await this.elevationService
      .getFauxboxCustomer(routingNum)
      .toPromise();
    this.allDealers = this.allDealers.sort((a, b) =>
      a.dealer_name.localeCompare(b.dealer_name),
    );

    if (!this.loadDealerFromStorage()) {
      this.setDealer(this.allDealers[0], true);
    }
  }

  getAllDealers(): any[] {
    return this.allDealers;
  }

  private loadDealerFromStorage() {
    const storedDealer = sessionStorage.getItem('currentDealer');
    if (storedDealer) {
      const parsedDealer = JSON.parse(storedDealer);
      if (
        this.allDealers.some(
          (dealer) => dealer.account_num === parsedDealer.account_num,
        )
      ) {
        this.setDealer(parsedDealer, false);
        return true;
      } else {
        this.clearDealer();
        return false;
      }
    }
    return false;
  }

  clearDealer(): void {
    sessionStorage.removeItem('currentDealer');
    this.currentDealerSubject.next(null);
  }
}
